import { jwtDecode } from "jwt-decode";

export interface JwtPayload {
  sub: string;
  jti: string;
  iat: number;
  exp: number;
  iss: string;
  aud: string;

  // Standard .NET claims
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress": string;
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;

  // Custom
  tenant_id: string;
}

export const getDecodedToken = (): JwtPayload | null => {
  const token = localStorage.getItem("token");

  if (!token) return null;

  try {
    return jwtDecode<JwtPayload>(token);
  } catch {
    return null;
  }
};

export const getUserRole = (): string | null => {
  return getDecodedToken()?.[
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
  ] ?? null;
};

export const getUserName = (): string | null => {
  return getDecodedToken()?.[
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
  ] ?? null;
};

export const getUserEmail = (): string | null => {
  return getDecodedToken()?.[
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
  ] ?? null;
};

export const getUserId = (): string | null => {
  const decoded = getDecodedToken();

  return (
    decoded?.sub ||
    decoded?.[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    ] ||
    null
  );
};

export const getTenantId = (): string | null => {
  return getDecodedToken()?.tenant_id ?? null;
};